import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosObj } from "../../../config/apiClients";
import { TemporaryCreditState } from "../../types";
import { queryParams } from "../../../utils/interface";

const initialState: TemporaryCreditState = {
  isLoading: false,
  totalCredits: 0,
  temporaryCredits: [],
  pagination: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false
  }
}

export const getAllTemporaryCredits = createAsyncThunk(
  "/temporaryCredits/getAll",
  async ({ paramPage, paramLimit, search, startDate, endDate }: queryParams, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get(
        `/temporaryCredits/getAll?paramPage=${paramPage}&paramLimit=${paramLimit}${search ? `&search=${search}` : ""}${startDate ? `&startDate=${startDate}` : ""}${endDate ? `&endDate=${endDate}` : ""}`);
      return response.data
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Temporary Credits' });
    }
  }
)

export const updateTemporaryCredits = createAsyncThunk(
  "/temporaryCredits/action",
  async ({ actionType, transactionId, userAccountId, transactionBank }: { actionType: string; transactionId: string, userAccountId: string, transactionBank?: string }, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('temporaryCredits/action', { actionType, transactionId, userAccountId, transactionBank });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Update Credit' });
    }
  }
);

const temporaryCreditSlice = createSlice({
  name: "TemporaryCredits",
  initialState,
  reducers: {
    updateCredits: (state, action) => {
      if (action.payload.actionType === "RELEASE_AMOUNT") {
        state.temporaryCredits = state.temporaryCredits.filter((item) => item._id !== action.payload.transactionId)
      } else if (action.payload.actionType === "FREEZE_ACCOUNT") {
        const index = state.temporaryCredits.findIndex((item) => item._id === action.payload.transactionId);
        if (index !== -1) {
          state.temporaryCredits[index].isFrozen = true;
        }
      } else if (action.payload.actionType === "UNFREEZE_ACCOUNT") {
        const index = state.temporaryCredits.findIndex((item) => item._id === action.payload.transactionId);
        if (index !== -1) {
          state.temporaryCredits[index].isFrozen = false;
        }
      }
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getAllTemporaryCredits.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllTemporaryCredits.fulfilled, (state, action) => {
        state.isLoading = false;
        state.temporaryCredits = action.payload.payload.allTemporaryCredits;
        state.totalCredits = action.payload.payload.totalCredits;
        state.pagination = {
          totalItems: action.payload.payload.totalItems,
          currentPage: action.payload.payload.page,
          totalPages: action.payload.payload.totalPages,
          hasNextPage: action.payload.payload.hasNextPage
        };
      })
      .addCase(getAllTemporaryCredits.rejected, (state) => {
        state.isLoading = false;
        state.temporaryCredits = [];
        state.totalCredits = 0;
      })
      .addCase(updateTemporaryCredits.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateTemporaryCredits.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateTemporaryCredits.rejected, (state) => {
        state.isLoading = false;
      });
  }
})

export const { updateCredits } = temporaryCreditSlice.actions;

export default temporaryCreditSlice.reducer;